export default __webpack_public_path__ + "a618108ddaca93bb228709fd9bf89cc1.mp3";